export const formatClient = (
  firstName,
  middleName,
  preferredName,
  lastName,
  mrn
) => {
  return `${mrn ? mrn + " - " : ""}${firstName ? firstName : ""} ${
    middleName ? middleName : ""
  } ${preferredName ? '"' + preferredName + '"' : ""} ${
    lastName ? lastName : ""
  }`;
};

export const formatEoc = (
  firstName,
  middleName,
  preferredName,
  lastName,
  mrn,
  episodeOfCareID
) => {
  return `${mrn ? mrn : ""}${episodeOfCareID ? "-" + episodeOfCareID : ""} ${
    firstName ? firstName : ""
  }${middleName ? " " + middleName : ""}${
    preferredName ? ' "' + preferredName + '"' : ""
  } ${lastName ? lastName : ""}`;
};

export const formatMrn = (mrn, episodeOfCareID) => {
  return `${mrn ? mrn : ""}${episodeOfCareID ? "-" + episodeOfCareID : ""}`;
};
